<template>
  <div id="serverError" :class="$mq">
    <h3>{{ $t("errors.server.title") }}</h3>
    <div :class="$mq" class="section">
      <div class="title">{{ $t("errors.server.subtitle") }}</div>
      <div><a href="/?newSession">{{ $t("errors.server.error-choice1") }}</a>
        {{ $t("errors.server.error-choice2") }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/ServerError.vue